<template>
  <ag-modal-container
    title="Ajouter un utilisateur"
    width="800px"
    @close="back"
  >
    <user-form
      v-model="value"
      :optional-password="false"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :loading="loading"
        :disabled="!isValid"
        color="accent"
        class="ml-5"
        @click="create"
        v-text="'Ajouter'"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import UserForm from '../components/UserForm'

export default {
  name: 'UserCreateContainer',
  components: {
    AgModalContainer,
    UserForm,
  },
  data: () => ({
    isValid: false,
    loading: false,
    value: {
      login: '',
      password: '',
      role: null,
      firstname: '',
      lastname: '',
      partsType: [],
    },
  }),
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async create () {
      this.loading = true
      try {
        await Repositories.user.post(this.value)
        this.showSuccessNotification(`L'utilisateur ${this.value.login} a bien été créé`)
        this.back()
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
